export default "__VITE_ASSET__C7TK0WYf__"